/**
 * Layout
 *
 * @author Heiko Pfefferkorn
 */

import {getRandomNumber, shuffleArray} from '../../shared/utils';

import SelectorEngine from '../../shared/dom/selector-engine';

import header from './header';
import menu from './menu';
import footer from './footer';
import search from './search';
import Manipulator from "../../shared/dom/manipulator";

// ------
// Private
// ------

/**
 *
 * @param min
 * @param max
 * @returns {number}
 */
const randomNumber = (min = 0, max = 9000) => {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

window.pageInstance.addBackgroundPattern = (elements = null) => {
	const baseClass     = 'bg-pattern';
	const patterns      = shuffleArray(window.pageInstance.config.backgroundPatterns ?? []);
	const countPatterns = patterns.length;

	if (!elements) {
		elements = SelectorEngine.find('.page-main > section:nth-of-type(odd)');
	}

	// Abbruch wenn keine Patterns oder keine Elemente verfügbar sind.
	if (countPatterns < 0 || elements.length <= 0) {
		return;
	}

	if (countPatterns === 1) {
		// Gibt es nur ein Pattern, dann aktualisiere nur das erste Element.

		Manipulator.addClass(elements[0], `${baseClass} ${patterns[0]} -bg-fixed`);
	} else {
		// Wähle ein Zufallspattern aus und aktualisiere das entspr. Element.

		let lastPattern = null;

		for (const element of elements) {
			let randomPattern = patterns[getRandomNumber(0, countPatterns -1)];

			// Ist `randomPattern` das gleiche wie `lastPattern`, dann wähle noch einmal.
			while (randomPattern === lastPattern){
				randomPattern = patterns[getRandomNumber(0, countPatterns -1)];
			}

			lastPattern = randomPattern;

			Manipulator.addClass(element, `${baseClass} ${randomPattern} -bg-fixed`);
		}
	}
};

// ------
// Public
// ------

const layout = () => {
	header();
	menu();
	footer();
	search();

	window.pageInstance.addBackgroundPattern();
};

// Export
export default layout;
